define('user/invite-user-confirmation-modal',['plugins/dialog', 'knockout'], function (dialog, ko) {
    var InviteUserConfirmationModal = function (success, failure) {
        var self = this;
        self.success = ko.observableArray(success);
        self.failure = ko.observableArray(failure);

        self.dismiss = function () {
            dialog.close(this);
        };
    };

    InviteUserConfirmationModal.show = function (success, failure) {
        return dialog.show(new InviteUserConfirmationModal(success, failure));
    };

    return InviteUserConfirmationModal;
});

